/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_No_Documents_AvailableInputs */

const en_orders_no_documents_available = /** @type {(inputs: Orders_No_Documents_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No documents available.`)
};

const es_orders_no_documents_available = /** @type {(inputs: Orders_No_Documents_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay documentos disponibles.`)
};

/**
* | output |
* | --- |
* | "No documents available." |
*
* @param {Orders_No_Documents_AvailableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_no_documents_available = /** @type {((inputs?: Orders_No_Documents_AvailableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_No_Documents_AvailableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_no_documents_available(inputs)
	return es_orders_no_documents_available(inputs)
});